<script>
import appConfig from '@src/app.config';
import { mapGetters, mapActions } from 'vuex';
import { Howl } from 'howler';
import { getFCM } from '@src/firebase';

window.Howler.autoUnlock = true;

const sound = new Howl({
  src: ['/sounds/notification.mp3'],
  volume: 1,
  mute: false,
});

const placedSound = new Howl({
  src: ['/sounds/notification_placed.mp3'],
  loop: true,
  volume: 1,
  mute: false,
  onplayerror: function(id, msg) {
    placedSound.once('unlock', function() {
      placedSound.play();
    });
  },
});

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  created() {
    // Subscribe push for resto user except admin
    if (this.user && this.user.name && (this.user.type !== 'admin')) {
      window.Howler.autoUnlock = true;
      const self = this;

      // Register service worker first
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then((registration) => {
            
            const messaging = getFCM();

            messaging.onMessage(function(payload) {
              self.storeOrderFromPush(payload);
            });
          })
          .catch((err) => {
            console.error('Service Worker registration failed:', err);
          });
      } else {
        console.error('Service Worker is not supported in this browser');
      }

      // Listen background message
      // if ('serviceWorker' in navigator) {
      //   navigator.serviceWorker.addEventListener('message', function(payload) {
      //     self.storeOrderFromPush(payload.data);
      //   });
      // }
    }
  },
  methods: {
    ...mapActions({
      storeNotyObj: 'app/fetchNotyObj',
      storeOrderObj: 'app/fetchOrderObj',
      sendNotificationAcknowledgement: 'app/sendNotificationAcknowledgement',
    }),
    storeOrderFromPush(pushPayload) {
      const pushData = pushPayload.data;
      if (pushPayload && pushData.order) {
        switch (pushData.prompt_action) {
          case 'buzz':
            sound.play();
            break;
          case 'check_food':
            const order = JSON.parse(pushData.order);
            if (order.status === 'PLACED') {
              let s1 = placedSound.play();
              placedSound.fade(1, 0, 10000, s1);
              window.placedSound = placedSound;
            } else {
              sound.play();
            }
            this.storeOrder(order);
            break;
          default:
            break;
        }
        // Notification acknoledgement send
        if (pushData.notification_id) {
          this.sendNotificationAcknowledgement(pushData.notification_id);
        }
      } else {
        this.$notification.success(pushPayload.notification.body);
        this.showNotification(pushPayload);
      }
    },
    storeOrder(order) {
      // let test = {
      //   id: '68390492-c734-44d9-a7b5-0b443d494ca2',
      //   tracking_id: '065db99c',
      //   status: 'PLACED',
      //   order_at: '2019-03-10T17:26:24.849335+06:00',
      // };
      this.storeOrderObj(order);
    },
    showNotification(message) {
      sound.play();
      const msgNotification = message.notification;
      if (msgNotification) {
        const obj = {
          title: msgNotification.title,
          body: msgNotification.body,
          type: msgNotification.type,
        };
        // this.newNotificationCounter++;
        // this.notifications.unshift(obj);
        // this.$bus.$emit('notification-event', obj);
        this.storeNotyObj(obj);

        // Notification acknoledgement send
        if (message.data && message.data.notification_id) {
          this.sendNotificationAcknowledgement(message.data.notification_id);
        }

        // TODO: show toast message
        // this.showToastr(
        //   msg.message.notification.type == undefined
        //     ? "info"
        //     : msg.message.notification.type,
        //   msg.message.notification.title,
        //   msg.message.notification.body
        // );

        // glow notification
        // $(".nav-notification").addClass("custom-notification");

        // clear glow if exists
        // if (this.notificationClearInterval) {
        //   clearInterval(this.notificationClearInterval);
        // }

        // clear glow after 120s
        // this.notificationClearInterval = setTimeout(() => {
        //   $(".nav-notification").removeClass("custom-notification");
        // }, 120000);
      }
    },
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
};
</script>

<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<style lang="scss">
@import "~nprogress/nprogress.css";

#nprogress .bar {
  background: #4caf50;
}
@import "assets/styles/app.scss";
</style>
